import React, { useEffect, useState, useRef, useContext } from 'react';
import useOutsideClick from '../../../hooks/useClickOutside';
import { setLocationCookie } from '../../helpers';

const DropdownFacet = props => {
  const {
    showNumberSelected = false,
    controller,
    facet = {
      id: 'facet-id',
      title: 'Facet Title',
      isSingleSelect: false
    },
    type = 'with-checkbox-and-results',
    immediateAction = false,
    onFacetChange = null,
    onResetFacet
  } = props;
  const [state, setState] = useState(controller.state);
  const [selectedValues, setSelectedValues] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const isInitialMount = useRef(true);

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
    });
  }, []);

  useEffect(() => {
    if (isInitialMount.current && controller.state.values.length > 0) {
      const hash = window.location.hash.slice(1);
      if (hash !== undefined) {
        const params = new URLSearchParams(hash);
        for (const [key, value] of params) {
          if (key.startsWith('f-' + props.facet.id)) {
            const values = value.split(',');
            const selected = controller.state.values.filter(item => values.includes(item.value));
            selected.forEach(item => {
              controller.toggleSelect(item);
            });
            setSelectedValues([...selectedValues, ...selected]);
          }
        }
      }
      isInitialMount.current = false;
    }
  }, [controller.state.values]);

  useEffect(() => {
    if (onResetFacet) {
      setSelectedValues([]);
    }
  }, [onResetFacet])

  useEffect(() => {
    if (onFacetChange) onFacetChange(facet, selectedValues);
    var data = JSON.parse('{ "' + facet.id + '": "' + selectedValues.map(item => item.value).join(',') + '"}');
    setLocationCookie(data);
  }, [selectedValues]);

  const handleFacetClick = value => {
    if (facet.isSingleSelect) {
      if (immediateAction) controller.toggleSingleSelect(value);
      if (selectedValues.includes(value)) {
        setSelectedValues([]);
      } else {
        setSelectedValues([value]);
      }
    } else {
      if (immediateAction) controller.toggleSelect(value);
      if (selectedValues.some(item => item.value === value.value)) {
        setSelectedValues(
          selectedValues.filter(item => item.value !== value.value)
        );
      } else {
        setSelectedValues([...selectedValues, value]);
      }
    }
  };

  const ref = useOutsideClick(() => {
    setExpanded(false);
  });

  const checkSelected = value => {
    if (immediateAction) return controller.isValueSelected(value);
    else return selectedValues.includes(value);
  };

  const renderFacet = value => {
    //type is one of
    //'with-checkbox-and-results'
    //'with-results'
    //'with-checkbox'
    //'with-underline-on-select'
    return (
      <div
        className={`listing-row-facet listing-row-facet--${type} ${
          checkSelected(value) || value.state === 'selected'
            ? 'listing-row-facet--selected'
            : ''
        } ${state.isLoading ? 'listing-row-facet--loading' : ''}`}
        onClick={() => handleFacetClick(value)}
      >
        <input
          type="checkbox"
          className="listing-row-facet__checkbox-input"
          value={value}
          aria-label={value.value}
          tabIndex="-1"
          disabled={state.isLoading}
          defaultChecked={checkSelected(value) || value.state === 'selected'}
        />
        <button
          className="listing-row-facet__checkbox-button"
          aria-label={value.value}
          disabled={state.isLoading}
          aria-checked={checkSelected(value) || value.state === 'selected'}
        ></button>
        <label
          className="listing-row-facet__label"
          title={value.value}
          aria-hidden="false"
        >
          {value.value}
        </label>
        {type === 'with-checkbox-and-results' && (
          <span className="listing-row-facet__results" aria-hidden="true">
            {value.numberOfResults}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="field dropdown-module" ref={ref}>
      <div className="field__input-label-wrapper">
        <div className="field__select-arrow-wrapper">
          <div className="dropdown ">
            <svg width="18" height="11" role="presentation">
              <use xlinkHref="#arrow-down"></use>
            </svg>
            <select
              aria-label="Dynamic Facet"
              className="field__select"
              tabIndex="-1"
            >
              <option value disabled>
                {facet.title}
              </option>
              {state.values.map(value => (
                <option key={value.value} value={value.value}>
                  {value.value}
                </option>
              ))}
            </select>
            <button
              aria-label={facet.title}
              className="dropdown__trigger field__select"
              type="button"
              aria-expanded={expanded}
              onClick={() => setExpanded(!expanded)}
            >
              <span>{facet.title}</span>
              {facet.isSingleSelect && selectedValues.length > 0 && (
                <span className="dropdown-secondary-label">
                  {
                    selectedValues.find(
                      item => item === selectedValues[selectedValues.length - 1]
                    ).value
                  }
                </span>
              )}
              {showNumberSelected && selectedValues.length > 0 && (
                <span className="dropdown-secondary-label">
                  {selectedValues.length} selected
                </span>
              )}
            </button>
            <div className="dropdown__list">
              <ul className="coveo-dynamic-facet-values">
                {state.values.map(value => (
                  <li className="dropdown-facet__value" key={value.value}>
                    {renderFacet(value)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropdownFacet;
